import { AmbientConversation } from "../../api/ambientConversation.type";
import { AmbientConvoListItem } from "./ambient-convo-list-item";

export function AmbientConvoList({
  items,
  onSelect,
}: {
  items: AmbientConversation[];
  onSelect: (id: string) => void;
}) {
  return (
    <ul className="divide-y">
      {items.map((c) => (
        <AmbientConvoListItem key={c.id} item={c} onSelect={onSelect} />
      ))}
    </ul>
  );
}
